import React from "react";
import { Sparkles, Gift } from "lucide-react";
import { useLanguage } from "../../contexts/LanguageContext";
import { CONTACT } from "../../lib/constants";
import { useReveal } from "../../hooks/useReveal";

export const SpecialOffer = () => {
  const { t } = useLanguage();
  const ref = useReveal();

  return (
    <section
      data-testid="offer-section"
      className="relative bg-accent-dark text-white py-16 md:py-20 overflow-hidden"
    >
      <div
        aria-hidden
        className="absolute inset-0 opacity-[0.06] pointer-events-none"
        style={{
          backgroundImage:
            "radial-gradient(circle at 20% 20%, #C8A97E 0, transparent 40%), radial-gradient(circle at 80% 80%, #C8A97E 0, transparent 35%)",
        }}
      />
      <div ref={ref} className="reveal relative max-w-5xl mx-auto px-6 md:px-10 text-center">
        <div className="inline-flex items-center gap-2 border border-gold/40 px-4 py-1.5 mb-8">
          <Sparkles size={14} className="text-gold" />
          <p className="text-[11px] tracking-[0.3em] uppercase text-gold font-medium">
            {t.offer.overline}
          </p>
        </div>

        <h2
          data-testid="offer-title"
          className="font-serif text-4xl sm:text-5xl md:text-6xl lg:text-7xl tracking-tight font-light leading-[1.05]"
        >
          {t.offer.title.includes("—") ? (
            <>
              {t.offer.title.split("—")[0]}
              <br />
              <span className="italic text-gold">— {t.offer.title.split("—")[1]?.trim()}</span>
            </>
          ) : (
            <span className="italic text-gold">{t.offer.title}</span>
          )}
        </h2>

        <p className="mt-7 text-white/75 text-base md:text-lg max-w-xl mx-auto leading-relaxed">
          {t.offer.subtitle}
        </p>

        <div className="mt-9 inline-flex items-center gap-3 bg-white/5 border border-white/10 px-5 py-3">
          <Gift size={16} className="text-gold" />
          <p className="text-sm text-white/85">{t.offer.bonus}</p>
        </div>

        <div className="mt-10">
          <a
            href={CONTACT.bookingForm}
            target="_blank"
            rel="noreferrer"
            data-testid="offer-cta"
            className="btn-luxury"
            style={{ padding: "1.1rem 2.5rem" }}
          >
            {t.offer.cta}
          </a>
          {t.offer.detail && (
            <p
              data-testid="offer-detail"
              className="mt-6 text-xs md:text-sm tracking-[0.15em] uppercase font-medium text-white/85"
            >
              {t.offer.detail}
            </p>
          )}
        </div>
      </div>
    </section>
  );
};
